import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await login(email, password);
    navigate('/');
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/50">
      <div className="w-full max-w-md space-y-8 rounded-xl border bg-card p-8 shadow-lg">
        <div className="text-center">
          <div className="ketchup-logo-wrap mx-auto inline-flex h-16 w-16 shrink-0 items-center justify-center">
            <img src="/ketchup-logo.png" alt="Ketchup SmartPay" className="h-12 w-12 rounded-lg object-contain" />
          </div>
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-foreground">Ketchup SmartPay</h2>
          <p className="mt-2 text-sm text-muted-foreground">Mobile Portal – sign in (field ops)</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-sm font-medium">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full rounded-lg border bg-background px-3 py-2 text-sm"
              placeholder="fieldop@ketchupsolutions.com"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full rounded-lg border bg-background px-3 py-2 text-sm"
            />
          </div>
          <button
            type="submit"
            className="w-full rounded-lg bg-primary py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary/90"
          >
            Sign In
          </button>
        </form>
        <p className="text-center text-sm text-muted-foreground mt-6">Portal: mobile.ketchup.cc</p>
      </div>
    </div>
  );
}
